import ApiClient from './ApiClient';

class CampaignFormsAPI extends ApiClient {
  constructor() {
    super('campaign_forms', { accountScoped: true });
  }

  fetchCampaignForms(params = {}){
    // return axios.get(`${this.url}?page=${page}`);
    return axios.get(`${this.url}`,{params});
  }
  fetchCampaignFormById(id){
    return axios.get(`${this.url}/${id}`,);
  }
  updateCampaignFormById(id,payload){
    return axios.patch(`${this.url}/${id}`,payload);
  }
  deleteCampaignFormById(id){
    return axios.delete(`${this.url}/${id}`,);
  }
  createCampaignForm(payload){
    return axios.post(`${this.url}/`,payload);
  }

  // publish form by id
  toggleCampaignFormPublish(id){
    return axios.get(`${this.url}/${id}/toggle_publish`,);
  }

  // get responders
  fetchFormRespondersById(id,params = {}){
    return axios.get(`${this.url}/${id}/form_responders`,{params});
  }
  exportFormRespondersById(id){
    return axios.get(`${this.url}/${id}/form_responders/export`,{
       responseType: 'blob'
    });
  }

}

export default new CampaignFormsAPI();
